/* ==========================================================================
   YorkshireArtsGB — product.js
   Variant picker, media gallery + zoom, quantity, sticky mobile bar.
   ========================================================================== */
(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var productSection = qs('[data-product-section]');
  if (!productSection) return;

  var dataEl = qs('[data-product-json]', productSection);
  var product = dataEl ? JSON.parse(dataEl.textContent) : null;
  var moneyFormat = productSection.getAttribute('data-money-format') || '£{{amount}}';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  /* ---------- Variant selection ---------- */
  var optionInputs = qsa('[data-option-input]', productSection);
  var idInput = qs('[data-variant-id]', productSection);
  var priceEl = qs('[data-product-price]', productSection);
  var comparePriceEl = qs('[data-product-compare-price]', productSection);
  var badgeEl = qs('[data-product-sale-badge]', productSection);
  var atcButton = qs('[data-add-to-cart]', productSection);
  var atcText = qs('[data-add-to-cart-text]', productSection);
  var buyButtons = qs('[data-payment-button]', productSection);
  var stickyPrice = qs('[data-sticky-price]');
  var digitalNote = qs('[data-digital-note]', productSection);
  var physicalNote = qs('[data-physical-note]', productSection);
  var physicalFeatures = qsa('[data-physical-feature]', productSection);
  var finishWrapper = qs('[data-physical-finish]', productSection);
  var finishInputs = qsa('[data-finish-input]', productSection);

  function groupValue(group) {
    var checked = qs('input:checked', group);
    var select = qs('select', group);
    return checked ? checked.value : (select ? select.value : '');
  }
  function setGroupValue(group, value) {
    qsa('input[data-option-input]', group).forEach(function (input) { input.checked = input.value === value; });
    var select = qs('select', group);
    if (select) select.value = qsa('option', select).some(function (o) { return o.value === value; }) ? value : '';
    var label = qs('[data-selected-value]', group);
    if (label) label.textContent = group.dataset.optionKind === 'size' ? value.split(' - ')[0] : (value === 'Print Only' ? 'Unframed' : value);
  }
  function selectedOptions() {
    var options = [];
    qsa('[data-option-index]', productSection).forEach(function (group) { options[Number(group.dataset.optionIndex)] = groupValue(group); });
    return options;
  }

  function findVariant(options) {
    if (!product) return null;
    return product.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === options[i]; });
    }) || null;
  }

  /* Keep dependent option groups compatible. Selecting a physical format
     automatically moves Size away from “Digital download”, while choosing
     Digital File restores the digital size. Size choices stay restricted
     to available variants of the selected format. */
  function syncDependentOptions(changedIndex) {
    if (!product) return;
    var groups = qsa('[data-option-index]', productSection);
    for (var i = Math.max(0, changedIndex + 1); i < groups.length; i++) {
      var prefix = groups.slice(0, i).map(groupValue);
      var validValues = product.variants.filter(function (v) {
        return v.available && prefix.every(function (value, index) { return v.options[index] === value; });
      }).map(function (v) { return v.options[i]; });
      qsa('input[data-option-input]', groups[i]).forEach(function (input) { input.disabled = validValues.indexOf(input.value) === -1; });
      qsa('select option', groups[i]).forEach(function (option) { option.disabled = !option.value || validValues.indexOf(option.value) === -1; });
      var value = groupValue(groups[i]);
      if (validValues.indexOf(value) === -1) value = validValues.find(function (v) { return /^A3(?: |$)/.test(v); }) || validValues[0] || '';
      setGroupValue(groups[i], value);
    }
  }
  function selectFramePreview(value) {
    var pattern = /black/i.test(value) ? /centered[_-]black|black frame mockup/i : /white/i.test(value) ? /centered[_-]blank[_-]white|white frame mockup/i : /oak/i.test(value) ? /centered[_-]empty[_-]oak|oak frame mockup/i : /cobalt|room mockup/i;
    var thumb = qsa('[data-thumb]', productSection).find(function (t) { return pattern.test((t.dataset.src || '') + ' ' + (t.dataset.alt || '')); });
    if (thumb) thumb.click();
  }

  /* Digital-vs-physical notices are driven by the selected FORMAT option
     (option 1), so they update correctly even for an incomplete/invalid
     Format + Size combination. */
  function updateFormatNotes() {
    var firstGroup = qs('[data-option-index="0"]', productSection);
    var checked = firstGroup ? qs('input:checked', firstGroup) : null;
    var select = firstGroup ? qs('select', firstGroup) : null;
    var value = checked ? checked.value : (select ? select.value : '');
    var isDigital = /digital/i.test(value);
    qsa('[data-digital-choice]', productSection).forEach(function (button) { button.setAttribute('aria-pressed', String(isDigital)); });
    if (digitalNote) digitalNote.toggleAttribute('hidden', !isDigital);
    if (physicalNote) physicalNote.toggleAttribute('hidden', isDigital);
    physicalFeatures.forEach(function (feature) { feature.toggleAttribute('hidden', isDigital); });
    if (finishWrapper) finishWrapper.toggleAttribute('hidden', isDigital);
    finishInputs.forEach(function (input) { input.disabled = isDigital; });
    if (!isDigital && finishInputs.length && !finishInputs.some(function (input) { return input.checked; })) finishInputs[0].checked = true;
  }

  function updateUI(variant) {
    if (!variant) {
      if (atcButton) {
        atcButton.setAttribute('disabled', '');
        if (atcText) atcText.textContent = window.variantStrings.unavailable;
      }
      return;
    }

    if (idInput) idInput.value = variant.id;

    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        comparePriceEl.removeAttribute('hidden');
        if (badgeEl) {
          var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          badgeEl.textContent = badgeEl.getAttribute('data-save-label').replace('[percent]', pct);
          badgeEl.removeAttribute('hidden');
        }
      } else {
        comparePriceEl.setAttribute('hidden', '');
        if (badgeEl) badgeEl.setAttribute('hidden', '');
      }
    }
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    if (atcButton) {
      if (variant.available) {
        atcButton.removeAttribute('disabled');
        if (atcText) atcText.textContent = window.variantStrings.addToCart;
      } else {
        atcButton.setAttribute('disabled', '');
        if (atcText) atcText.textContent = window.variantStrings.soldOut;
      }
    }
    if (buyButtons) buyButtons.classList.toggle('hidden', !variant.available);

    if (variant.featured_media && variant.featured_media.id) {
      var mediaBtn = qs('[data-thumb][data-media-id="' + variant.featured_media.id + '"]', productSection);
      if (mediaBtn) mediaBtn.click();
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  optionInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      var group = input.closest('[data-option-index]');
      setGroupValue(group, input.value);
      var changedIndex = parseInt(group.getAttribute('data-option-index'), 10);
      syncDependentOptions(isNaN(changedIndex) ? -1 : changedIndex);
      updateUI(findVariant(selectedOptions()));
      updateFormatNotes();
      if (group.dataset.optionKind === 'format') selectFramePreview(input.value);
    });
  });



  qsa('[data-digital-choice]', productSection).forEach(function (button) {
    button.addEventListener('click', function () {
      var input = qs('[data-option-kind="format"] .product__frame-choice--digital input', productSection);
      if (input && !input.disabled) input.click();
    });
  });

  /* ---------- Media gallery and full-screen viewer ---------- */
  var mainWrap = qs('[data-main-media]', productSection);
  var mainImg = mainWrap ? qs('img', mainWrap) : null;
  var thumbs = qsa('[data-thumb]', productSection);
  var lightbox = qs('[data-product-lightbox]', productSection);
  var viewerImg = lightbox ? qs('[data-lightbox-image]', lightbox) : null;
  var viewerStage = lightbox ? qs('[data-lightbox-stage]', lightbox) : null;
  var viewerCount = lightbox ? qs('[data-lightbox-count]', lightbox) : null;
  var viewerLevel = lightbox ? qs('[data-lightbox-level]', lightbox) : null;
  var zoomIn = lightbox ? qs('[data-lightbox-zoom-in]', lightbox) : null;
  var zoomOut = lightbox ? qs('[data-lightbox-zoom-out]', lightbox) : null;
  var zoomFit = lightbox ? qs('[data-lightbox-fit]', lightbox) : null;
  var zoom = 1;
  var panX = 0;
  var panY = 0;
  var drag = null;
  var suppressClick = false;
  var restoreFocus = null;
  var restoreOverflow = '';

  function activeMediaIndex() {
    var index = thumbs.findIndex(function (thumb) { return thumb.getAttribute('aria-current') === 'true'; });
    return index < 0 ? 0 : index;
  }

  function clampPan() {
    if (!viewerImg || !viewerStage) return;
    var limitX = Math.max(0, (viewerImg.offsetWidth * zoom - viewerStage.clientWidth) / 2);
    var limitY = Math.max(0, (viewerImg.offsetHeight * zoom - viewerStage.clientHeight) / 2);
    panX = Math.max(-limitX, Math.min(limitX, panX));
    panY = Math.max(-limitY, Math.min(limitY, panY));
  }

  function renderZoom() {
    if (!viewerImg) return;
    viewerImg.style.maxHeight = Math.max(1, viewerStage.clientHeight) + 'px';
    clampPan();
    viewerImg.style.transform = 'translate(' + panX + 'px, ' + panY + 'px) scale(' + zoom + ')';
    viewerStage.classList.toggle('is-zoomed', zoom > 1);
    viewerLevel.textContent = Math.round(zoom * 100) + '%';
    zoomOut.disabled = zoom <= 1;
    zoomIn.disabled = zoom >= 3;
    zoomFit.disabled = zoom === 1;
  }

  function setZoom(value) {
    zoom = Math.max(1, Math.min(3, value));
    if (zoom === 1) { panX = 0; panY = 0; }
    renderZoom();
  }

  function displayViewerImage() {
    if (!viewerImg || !mainImg) return;
    viewerImg.src = mainWrap.getAttribute('data-full') || mainImg.currentSrc || mainImg.src;
    viewerImg.alt = mainImg.alt || '';
    viewerCount.textContent = (activeMediaIndex() + 1) + ' / ' + (thumbs.length || 1);
    setZoom(1);
  }

  function selectMedia(index) {
    var thumb = thumbs[index];
    if (!thumb || !mainImg) return;
    mainImg.src = thumb.getAttribute('data-src');
    mainImg.srcset = thumb.getAttribute('data-srcset') || '';
    mainImg.alt = thumb.getAttribute('data-alt') || '';
    mainWrap.setAttribute('data-full', thumb.getAttribute('data-full') || mainImg.src);
    thumbs.forEach(function (item) { item.setAttribute('aria-current', 'false'); });
    thumb.setAttribute('aria-current', 'true');
    if (lightbox && lightbox.open) displayViewerImage();
  }

  thumbs.forEach(function (thumb, index) {
    thumb.addEventListener('click', function () { selectMedia(index); });
  });

  if (mainWrap && mainImg && lightbox && viewerImg) {
    function finishViewerClose() {
      document.body.style.overflow = restoreOverflow;
      if (restoreFocus && restoreFocus.isConnected) restoreFocus.focus();
      restoreFocus = null;
    }

    function closeViewer() {
      if (!lightbox.open) return;
      lightbox.close();
      finishViewerClose();
    }

    function openViewer() {
      if (lightbox.open) return;
      restoreFocus = document.activeElement;
      restoreOverflow = document.body.style.overflow;
      displayViewerImage();
      lightbox.showModal();
      renderZoom();
      document.body.style.overflow = 'hidden';
      qs('[data-lightbox-close]', lightbox).focus();
    }

    mainWrap.addEventListener('click', openViewer);
    mainWrap.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openViewer();
      }
    });

    qs('[data-lightbox-close]', lightbox).addEventListener('click', closeViewer);
    qs('[data-lightbox-prev]', lightbox).addEventListener('click', function () {
      if (thumbs.length) selectMedia((activeMediaIndex() - 1 + thumbs.length) % thumbs.length);
    });
    qs('[data-lightbox-next]', lightbox).addEventListener('click', function () {
      if (thumbs.length) selectMedia((activeMediaIndex() + 1) % thumbs.length);
    });
    zoomOut.addEventListener('click', function () { setZoom(zoom - 0.5); });
    zoomIn.addEventListener('click', function () { setZoom(zoom + 0.5); });
    zoomFit.addEventListener('click', function () { setZoom(1); });
    viewerImg.addEventListener('load', renderZoom);

    lightbox.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft' && thumbs.length) { event.preventDefault(); selectMedia((activeMediaIndex() - 1 + thumbs.length) % thumbs.length); }
      if (event.key === 'ArrowRight' && thumbs.length) { event.preventDefault(); selectMedia((activeMediaIndex() + 1) % thumbs.length); }
      if (event.key === '+' || event.key === '=') { event.preventDefault(); setZoom(zoom + 0.5); }
      if (event.key === '-') { event.preventDefault(); setZoom(zoom - 0.5); }
      if (event.key === '0') { event.preventDefault(); setZoom(1); }
    });
    lightbox.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeViewer();
    });
    lightbox.addEventListener('close', function () {
      if (!lightbox.open && restoreFocus) finishViewerClose();
    });
    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) closeViewer();
    });

    viewerStage.addEventListener('pointerdown', function (event) {
      if (zoom <= 1 || (event.target.closest && event.target.closest('button'))) return;
      drag = { id: event.pointerId, x: event.clientX, y: event.clientY, panX: panX, panY: panY, moved: false };
      viewerStage.setPointerCapture(event.pointerId);
    });
    viewerStage.addEventListener('pointermove', function (event) {
      if (!drag || drag.id !== event.pointerId) return;
      var dx = event.clientX - drag.x;
      var dy = event.clientY - drag.y;
      if (Math.abs(dx) > 3 || Math.abs(dy) > 3) drag.moved = true;
      panX = drag.panX + dx;
      panY = drag.panY + dy;
      renderZoom();
    });
    function endDrag(event) {
      if (!drag || drag.id !== event.pointerId) return;
      if (drag.moved) {
        suppressClick = true;
        window.setTimeout(function () { suppressClick = false; }, 250);
      }
      drag = null;
    }
    viewerStage.addEventListener('pointerup', endDrag);
    viewerStage.addEventListener('pointercancel', endDrag);
    viewerStage.addEventListener('click', function (event) {
      if (suppressClick) { suppressClick = false; return; }
      if (event.target === viewerImg) setZoom(zoom === 1 ? 2 : 1);
      else if (event.target === viewerStage && zoom === 1) closeViewer();
    });
    window.addEventListener('resize', function () { if (lightbox.open) renderZoom(); });
  }

  /* Initialise after gallery handlers so an existing variant image can be selected. */
  syncDependentOptions(-1);
  updateUI(findVariant(selectedOptions()));
  updateFormatNotes();
  var sizeDialog = qs('[data-size-dialog]', productSection);
  var initialFormat = qs('[data-option-kind="format"]', productSection);
  if (initialFormat && /black|white|oak/i.test(groupValue(initialFormat))) selectFramePreview(groupValue(initialFormat));
  qsa('[data-size-guide]', productSection).forEach(function (button) { button.addEventListener('click', function () { if (sizeDialog) sizeDialog.showModal(); }); });
  if (sizeDialog) {
    qs('[data-close-size-guide]', sizeDialog).addEventListener('click', function () { sizeDialog.close(); });
    sizeDialog.addEventListener('click', function (event) { if (event.target === sizeDialog) sizeDialog.close(); });
  }

  /* ---------- Quantity ---------- */
  var qtyInput = qs('[data-product-quantity]', productSection);
  qsa('[data-product-quantity-change]', productSection).forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyInput) return;
      var delta = parseInt(btn.getAttribute('data-product-quantity-change'), 10);
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
    });
  });

  /* ---------- Sticky mobile bar ---------- */
  var stickyBar = qs('[data-sticky-bar]');
  var buyBlock = qs('[data-buy-block]', productSection);
  if (stickyBar && buyBlock && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 });
    observer.observe(buyBlock);
    var stickyBtn = qs('[data-sticky-add]', stickyBar);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var y = buyBlock.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    }
  }
})();


